var ResponseStatuses;
(function (ResponseStatuses) {
    ResponseStatuses[ResponseStatuses["Unauthorized"] = 401] = "Unauthorized";
    ResponseStatuses[ResponseStatuses["Forbidden"] = 403] = "Forbidden";
})(ResponseStatuses || (ResponseStatuses = {}));
export { ResponseStatuses };
